import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/recaudacion/tipos-de-gasto/';

/**
 * GET Tipos de Gastos
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeGastos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Gasto
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeGasto = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Tipo de Gasto
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeGasto = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Gasto
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeGasto = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Gasto
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeGasto = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
